import * as React from 'react';

import {FormSection} from 'redux-form';

import type {QueuedEmail as QueuedEmailFragment} from 'nutshell-graphql-types';

import {EmailFormSection} from '../../sender/fields/email-form-section';

import {EmailAddressField} from './email-address-field';

import styles from './email-composer-form.module.css';

type Props = {
    editingEmailId: string;
    queuedEmails: QueuedEmailFragment[];
    isMultiSequence: boolean;
    onChangePlaintextBody: (arg1: string, arg2: string) => void;
    onChangeSubject: (arg1: string, arg2: string) => void;
};

export class EmailComposerForm extends React.PureComponent<Props> {
    render() {
        const email = this.props.queuedEmails.find((queuedEmail) => {
            return queuedEmail.id === this.props.editingEmailId;
        });

        if (!email) {
            // Error state?
            return null;
        }

        return (
            <div className={styles['email-composer-form']}>
                <EmailAddressField label='From' value={email.from.formatted} />
                <EmailAddressField
                    label='To'
                    value={email.to
                        .map((address) => {
                            return address.display;
                        })
                        .join()}
                />
                {email.cc && email.cc.length ? (
                    <EmailAddressField
                        label='Cc'
                        value={email.cc
                            .map((address) => {
                                return address.display;
                            })
                            .join()}
                    />
                ) : undefined}
                <div className={styles['composer-fields']}>
                    {this.props.queuedEmails.map((queuedEmail) => {
                        return (
                            <FormSection name={queuedEmail.id} key={queuedEmail.id}>
                                <EmailFormSection
                                    isMultiSequence={this.props.isMultiSequence}
                                    isActive={queuedEmail.id === this.props.editingEmailId}
                                    sendAsReply={queuedEmail.sendAsReply}
                                    onBodyChange={this.handleBodyChange(queuedEmail.id)}
                                    onSubjectChange={this.handleSubjectChange(queuedEmail.id)}
                                    fileAttachmentFieldName={null}
                                />
                            </FormSection>
                        );
                    })}
                </div>
            </div>
        );
    }

    /*
     * The reason for this to exist is that we want to be able to get the plain
     * text from react-quill's editor, so that we can show a plaintext body
     * in the template list.
     */
    handleBodyChange =
        (id: string) =>
        ({onChange}: {onChange: (...args: any) => any}) =>
        (newHtml: string, newText: string) => {
            onChange(newHtml);
            this.props.onChangePlaintextBody(newText, id);
        };

    handleSubjectChange = (id: string) => (value: string) => {
        this.props.onChangeSubject(value, id);
    };
}
